export default function FormRadio({ field, value, error, onChange }) {
  const handleChange = (optionValue) => {
    onChange(field.name, optionValue);
  };

  return (
    <div className="w-full">
      <label className="block text-sm font-medium text-gray-200 mb-3">
        {field.label}
        {field.required && <span className="text-aw-green font-semibold text-lg ml-1">*</span>}
      </label>
      <div className="flex items-center flex-wrap gap-2">
        {field.options &&
          field.options.map((option, index) => {
            // Support both string array and object array
            const optionValue = typeof option === "string" ? option : option.value;
            const optionLabel = typeof option === "string" ? option : option.label;
            const isChecked = value === optionValue;

            return (
              <label
                key={index}
                className={`flex items-center gap-3 p-3 rounded-lg border-2 cursor-pointer transition-all duration-200 ${
                  isChecked
                    ? "border-gray-300"
                    : "border-aw-bluedark hover:border-gray-700"
                } ${error ? "border-red-500" : ""}`}
              >
                <input
                  type="radio"
                  name={field.name}
                  value={optionValue}
                  checked={isChecked}
                  onChange={() => handleChange(optionValue)}
                  className="w-4 h-4 accent-aw-bluedark cursor-pointer"
                />
                <span className="text-gray-200 font-medium w-full">{optionLabel}</span>
              </label>
            );
          })}
      </div>
      {error && <p className="text-xs text-red-500 mt-2">{error}</p>}
      {field.helpText && !error && (
        <p className="text-xs text-gray-500 mt-2">{field.helpText}</p>
      )}
    </div>
  );
}
